import {
  INPUT_BORDER_FOCUS_COLOR,
  INPUT_BORDER_HOVER_COLOR,
  INPUT_BORDER_COLOR,
} from 'now-frontend-shared/themes/colors';

export const customInputStyles = {
  fieldStyles: {
    width: '100%',
    padding: '6px 8px',
    height: '80%',
    fontWeight: '500',
    fontSize: '15px',
    border: `1px solid ${INPUT_BORDER_COLOR}`,
    borderRadius: '4px',
    outline: 'none',
    textAlign: 'left',
    color: '#000000',
    background: '#fff',
    '&:hover': {
      border: `1px solid ${INPUT_BORDER_HOVER_COLOR}`,
    },
    '&:focus': {
      border: `1px solid ${INPUT_BORDER_FOCUS_COLOR}`,
      boxShadow: `0px 0px 0px 1px ${INPUT_BORDER_FOCUS_COLOR} inset`,
    },
    '&::placeholder': {
      fontWeight: '400',
      fontSize: '10px',
    },
  },
};
